import React from 'react';
import { AlertCircle } from 'react-feather';
import cn from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import {
  AUTOMATED_ANALYSIS_ERRORS,
  SMALL_WORD_COUNT_ERROR_TEXT,
  RESULTS_UNAVAILABLE_ERROR_TEXT,
  TRANSCRIPT_UNABLE_TO_PROCESS_ERROR_TEXT,
  TRANSCRIPT_NONE,
  TRANSCRIPT_SYSTEM_ISSUE_ENCOUNTERED_ERROR_TEXT,
} from 'constants/automatedAnalysis';

const IncompleteAssessmentSection = ({
  status,
  error,
  processText,
  invalidValue = false,
  invalidAssessmentError,
}) => {
  const isProcessing = status === 'waiting' || status === 'pending';
  const isTranscript = processText === t('automated_analysis.transcript.title');
  const isKeywordMatching =
    processText === t('automated_analysis.keyword_matching.title');
  const assessmentError = invalidAssessmentError?.transcriptionError;
  const expectedErrors = [
    SMALL_WORD_COUNT_ERROR_TEXT,
    TRANSCRIPT_UNABLE_TO_PROCESS_ERROR_TEXT,
  ];

  const errorText = () => {
    if (isTranscript) {
      switch (assessmentError) {
        case AUTOMATED_ANALYSIS_ERRORS.SMALL_WORD_COUNT:
          return TRANSCRIPT_UNABLE_TO_PROCESS_ERROR_TEXT;
        case AUTOMATED_ANALYSIS_ERRORS.NO_AUDIO:
          return TRANSCRIPT_NONE;
        default:
          return TRANSCRIPT_SYSTEM_ISSUE_ENCOUNTERED_ERROR_TEXT;
      }
    }

    switch (assessmentError) {
      case AUTOMATED_ANALYSIS_ERRORS.SMALL_WORD_COUNT:
        return SMALL_WORD_COUNT_ERROR_TEXT;
      default:
        return RESULTS_UNAVAILABLE_ERROR_TEXT;
    }
  };

  const isExpectedError = expectedErrors.includes(errorText());

  return (
    <div
      className={cn({
        'mt-32': isProcessing && !isTranscript && !isKeywordMatching,
      })}
    >
      {!error && isProcessing && (
        <Text className="fs-i ml-16" variant={TEXT_VARIANTS.BODY}>
          {t('automated_analysis.grading_station.processing')}
        </Text>
      )}
      {error && (
        <div
          className={cn('d-f ai-c', {
            'fd-c': !isTranscript && !isKeywordMatching,
          })}
        >
          <AlertCircle className="c-error mr-6" width={16} />
          <Text
            className={cn('c-error mr-10 ml-6')}
            variant={TEXT_VARIANTS.BODY}
          >
            {isTranscript
              ? t('automated_analysis.grading_station.transcript.network_error')
              : t('automated_analysis.grading_station.results_unavailable')}
          </Text>
        </div>
      )}
      {!error &&
        (status === 'failed' ||
          status === 'unrecoverable' ||
          (status === 'complete' && invalidValue)) && (
          <div
            className={cn('d-f ai-c incomplete-assessment-section', {
              'incomplete-assessment--not-transcript-or-keyword-matching':
                !isTranscript && !isKeywordMatching,
              'incomplete-assessment--expected-error': isExpectedError,
              'incomplete-assessment--unexpected-error': !isExpectedError,
            })}
          >
            <AlertCircle width={16} />
            <Text variant={TEXT_VARIANTS.BODY}>{errorText()}</Text>
          </div>
        )}
    </div>
  );
};

export default IncompleteAssessmentSection;
